// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + ({"607":"Root","836":"EmbeddedLoader"}[chunkId] || chunkId) + "." + {"469":"db514ad0","607":"61e88532","836":"ea06e057"}[chunkId] + ".chunk.js";
};